import { useTranslation } from "react-i18next";
import { useModal } from "../../context/ModalContext";
import { useToast } from "../../context/ToastContext";
import { SolarGlobalBoldDuotone } from "../icons/SolarGlobalBoldDuotone";
import { useGlobal } from "../../context/GlobalContext";
import { getButtonsNoYes, getButtonsNoYesDanger } from "../../context/helpers/helperModalContext";
import SvgTrash from "../svg/SvgTrash";
import ESpinner from "../others/Spinner";
import { useState } from "react";
import PublishedSiteDlg from "./PublishedSiteDlg";

const PublishedSiteButton = () => { 

    const { showDlg } = useModal(); 
    const { t } = useTranslation(['common', 'SitePages']);
    const { g } = useGlobal();
    const [ showPublishedDlg, setShowPublishedDlg ] = useState(false);
    const [ showSpinner, setShowSpinner ] = useState(true);
 
   

    return (
        <>
        <div className="pc-h-item ">
            <span className="pc-head-link ms-0 cursor-pointer"
                onClick={()=>{ 
                    setShowPublishedDlg(true)
                }}>
                <SolarGlobalBoldDuotone/>
            </span>
        </div>
        <PublishedSiteDlg
            showPublishedDlg={showPublishedDlg} 
            setShowPublishedDlg={setShowPublishedDlg}/>
        </>
        

    )
}

export default PublishedSiteButton;